import { BlockDataForm } from '@plone/volto/components';
import { InfoBoxSchema } from './schema';

const InfoBoxData = (props) => {
  const { data, block, onChangeBlock, blocksConfig } = props;
  const schema = InfoBoxSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
      blocksConfig={blocksConfig}
    />
  );
};

export default InfoBoxData;
